export function flyout(trigger) {
  let {
    top,
    left,
    width
  } = trigger.getBoundingClientRect();
  let style = {
    left: left + width,
    top: top + window.pageYOffset
  };
  return {
    style
  };
}